import { render, staticRenderFns } from "./accountantSummaryDriverProvince.vue?vue&type=template&id=06c5d136"
import script from "./accountantSummaryDriverProvince.vue?vue&type=script&lang=js"
export * from "./accountantSummaryDriverProvince.vue?vue&type=script&lang=js"
import style0 from "./accountantSummaryDriverProvince.vue?vue&type=style&index=0&id=06c5d136&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports